import { gosNREUMOriginals } from '../../window/nreum.mjs';

const originals = gosNREUMOriginals().o;

export { originals };
//# sourceMappingURL=originals.mjs.map
